<template>
  <div>
    <Divider orientation="left">咨询信息</Divider>
    <div class="chartInfo">
      <table>
        <tbody>
          <tr>
            <td>咨询编号</td>
            <td>{{mc.code}}</td>
            <td>咨询时间</td>
            <td>{{mc.whenCreated}}</td>
          </tr>
          <tr>
            <td>所属区域</td>
            <td>{{mc.areaName}}</td>

            <td>咨询时间</td>
            <td>{{mc.whenCreated}}</td>
          </tr>

          <tr v-if="!showSimple">
            <td>咨询人姓名</td>
            <td>{{mc.commentUser | desensitizedName}}</td>

            <td>联系方式</td>
            <td>{{mc.commentTel | desensitizedPhone}}</td>
          </tr>

          <tr>
            <td>咨询标题</td>
            <td colspan="3">{{mc.commentTitle}}</td>
          </tr>
          <tr>
            <td>咨询内容</td>
            <td colspan="3">{{mc.commentInfo}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <Divider orientation="left">回复信息</Divider>
    <div class="chartInfo">
      <table>
        <tbody>
          <tr>
            <td>回复人</td>
            <td>{{mc.consultationReply?.replyUserName}}</td>
            <td>回复时间</td>
            <td>{{mc.consultationReply?.whenCreated}}</td>
          </tr>
          <tr></tr>
          <tr>
            <td>回复内容</td>
            <td colspan="3">{{mc.consultationReply?.replyInfo}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <template v-if="mc.satisfactionEvaluated && !showSimple">
      <Divider orientation="left">满意度信息</Divider>
      <div class="chartInfo">
        <div class="satisfactionLogContainer">
          <div :class="satisfactionLog?.satisfactionResult+' satisfactionIcon'"></div>
          <template v-if="satisfactionLog">
            <table>
              <tr>
                <td>整体评价</td>
                <td :colspan="(subOpts.length * 2 -2)/2">{{satisfactionLog.satisfactionResultLabel}}</td>
                <td>数据来源</td>
                <td
                  :colspan="(subOpts.length * 2 -2)/2"
                >{{satisfactionLog.isDefaultValue?'系统默认':'咨询人评价'}}</td>
              </tr>
              <template
                v-if="satisfactionResultMap[satisfactionLog?.satisfactionResult]?.showSub && satisfactionLog.items"
              >
                <tr>
                  <template v-for="item in satisfactionLog.items">
                    <td
                      :key="item.evaluationDimension + 'evaluationDimensionLabel'"
                    >{{subOptsMap[item.evaluationDimension]}}</td>
                    <td
                      :key="item.evaluationDimension + 'evaluationDimension'"
                    >{{item.satisfactionResultLabel}}</td>
                  </template>
                </tr>
                <tr>
                  <td>问题</td>
                  <td
                    :colspan="subOpts.length * 2 -1"
                    style="text-align: left"
                  >{{satisfactionLog.remark}}</td>
                </tr>
              </template>
            </table>
          </template>
          <div class="textC" style="line-height: 4rem" v-else>暂无评价</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'mcDetail',
  props: {
    mc: {
      required: true
    },
    showSimple: {
      required: false,
      default: false
    },
  },
  watch: {
    mc: {
      immediate: true,
      handler: function (val) {
        if (val?.satisfactionEvaluated && !this.showSimple) {
          this.getSatisfactionLog()
        }
      }
    }
  },
  data () {
    return {
      satisfactionLog: null,
      satisfactionOptions: [],
      satisfactionResultMap: {},
      subOptsMap: {
        // service: '服务态度',
        // efficiency: '效率',
        // environment: '环境',
        // ability: '能力',
        // honest: '廉洁',
        // other: '其它'
      },
      subOpts: [],
    }
  },
  methods: {
    loadSatisfactionResults: async function () {
      this.satisfactionOptions = await this.$baseData.handleData(false, this.$apis.common.satisfactionResultOptions, null) || []
      this.satisfactionOptions.forEach(item => {
        this.satisfactionResultMap[item.value] = item
      })
    },
    evaluationDimensionOptions: async function () {
      this.subOpts = await this.$baseData.handleData(false, this.$apis.common.evaluationDimensionOptions, null) || []
      this.subOpts.forEach(item => {
        this.subOptsMap[item.value] = item.label
      })
    },
    getSatisfactionLog: function () {
      let that = this
      this.satisfactionLog = null
      let params = new this.$URLSearchParams()
      params.append("consultationId", this.mc.id)
      params.append("icType", "MC")
      this.$axios.post(that.$apis.common.satisfactionLog, params).then(res => {
        if (res.success) {
          that.satisfactionLog = res.result
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取满意度信息失败！')
      })
    },

  },
  beforeMount () {
    this.loadSatisfactionResults()
    this.evaluationDimensionOptions()
  }
}
</script>
<style lang="less" scoped>
.chartInfo {
  position: relative;
  margin-bottom: 10px;
  table {
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
    tr {
      td {
        border: 1px solid #e8e9ec;
        padding: 10px;
      }
    }
  }
}
</style>